/// <reference path="../../ng-services/chat.service.ts"/>

import { Meeting } from '../../models/chat';
import { ChatAttachmentUploadService } from '../../ng-services/chat-attachment-upload.service';
import { ChatMessageInputStore, ChatMessageUpload } from '../../ng-services/chat-message-input.store';

(function () {
    class ChatMessageUploadComponent {
        static $inject = ['ChatMessageInputStore', 'ChatAttachmentUploadService'];

        public conversation!: Meeting;

        public uploads: ChatMessageUpload[] = [];

        // todo: move
        private subscribes: Rx.IDisposable[] = [];

        constructor(
            private chatMessageInputStore: ChatMessageInputStore,
            private attachmentUploadService: ChatAttachmentUploadService
        ) {}

        $onDestroy() {
            this.subscribes.forEach((d) => d.dispose());
        }

        $onInit() {
            this.subscribes = [
                this.chatMessageInputStore.getMessageInputState$(this.conversation.id).subscribe((s) => {
                    this.uploads = s.uploads;
                }),
            ];
        }

        remove(hash: string) {
            this.chatMessageInputStore.dispatchRemoveUpload(this.conversation.id, hash);
        }

        protected upload(file: File) {
            this.attachmentUploadService.upload(this.conversation, file);
        }
    }

    angular.module('tradersyard').component('tyChatMessageUpload', {
        template: `<div class="chat_message_upload">
    <div class="chat_message_upload__filelist" is-uib>
        <div class="chat_message_upload_file" ng-repeat="upload in $ctrl.uploads">
            <span class="chat_message_upload_file__remove" uib-tooltip="Remove file"
               ng-click="$ctrl.remove(upload.hash)">
                <i class="fa fa-times"/>
            </span>

            <div class="chat_message_upload_file__details">
                <div class="chat_message_upload_file__thumbnail">
                    <i class="fa fa-file" ng-if="!upload.imageUrl"></i>
                    <img ng-src="{{upload.imageUrl}}" alt="{{upload.name}}" ng-if="upload.imageUrl">
                </div>
                <div class="chat_message_upload_file__name" ng-if="!upload.imageUrl">
                    {{upload.name}}
                </div>
            </div>
            <uib-progressbar value="upload.progress" type="primary"
                             class="chat_message_upload_file__progress progress-striped active"
                             ng-hide="upload.progress >= 100"/>
        </div>
    </div>
</div>
        `,
        controller: ChatMessageUploadComponent,
        bindings: {
            conversation: '<',
        },
    });
})();
